(function ($) {
	//block button and cart on load
	blockCart();

	window.addEventListener('load', function() {
		//unblock buttoon after load page
		jQuery('.woocommerce-cart-form').removeClass('block-cart');
		jQuery('.coala-add-to-cart-button').removeClass('block-cart');
	});


	jQuery(document).ready(function () {
		toggleCart($('.top-nav-cart'), 'open');
		toggleCart($('.close-cart-button'), 'close');

		openCartIfSetCookie();
		preventBodyScolling();
		addProductToCart();
		//refreshAfterAddedToCart();
		removeProductFromCart();
		addCoupon();
		removeCoupon();
		updateCartQuantityInput();
		increaseQuantityValue($('.quantity-wrapper .quantity-plus'));
		increaseQuantityValue($('.cart-product-quantity .quantity-plus'), true);
		decreaseQuantityValue($('.quantity-wrapper .quantity-minus'));
		decreaseQuantityValue($('.cart-product-quantity .quantity-minus'), true);
		loadMoreOrders();
		loadMoreProducts();
		toggleLanguageSwitcher();
		toggleCurrencySwitcher();
		shareLink();
		checkoutSelectType();
		showHideCategoryNav();
		showHideCategoryNavSumbenu();
		stopAddMoreProductByInput();

		selectDefaultCountry();
		/* login register */
		catchLoginRegisterNotices();
		/* checkout switch address */
		checkoutDeliveryToDifferentAddress();
		hideCartNotices();

		refreshCartAndIconFromLocal();

		clearCartAfterAddToCartBundleProduct();

		/* navigate on checkout page */
		navOnCheckout();
		navOnHistoryBack();

		jQuery(document.body).on('updated_checkout', function () {
			checkNavOnCheckout();
			getDataFromCheckoutSteps();
			refreshHeaderCartIcon();
			refreshCart();

		});
		jQuery(document.body).on('checkout_error', function (e, error_message) {
			validateCheckout(error_message);
			checkoutValidationTestMessage(error_message, false);
			console.log(error_message);
			refreshHeaderCartIcon();
			refreshCart();
		});

		if (jQuery('body').hasClass('woocommerce-order-received')) {
			refreshHeaderCartIcon();
			refreshCart();
		}

		if (jQuery('body').hasClass('home')) {
			refreshHeaderCartIcon();
			refreshCart();
		}

	});

	/*
 * Add your functions triggered after all media and page loaded
 */
	// jQuery(window).on('load', function () {
	// 	//unblock buttoon after load page
	// 	unBlockCart();
	// });


	/* if cookies set, open cart */
	function openCartIfSetCookie() {
		let cartOpen = getCookie('is_cart_opened');
		if (cartOpen === 'yes' && !$('body').hasClass('woocommerce-order-received')) {
			openCart();
		} else if ($('body').hasClass('woocommerce-order-received')) {
			document.cookie = "is_cart_opened = no; path=/";
		}
	}

	/* Toggle Cart */
	function openCart() {
		//const bodyClass = $('body').attr("class").split(/\s+/);
		$('.cart-main-container').addClass('cart-main-container--opened');
		//$('body').addClass('is-blocked');
		if (!$('body').hasClass('is-mobile')) {
			document.cookie = "is_cart_opened = yes; path=/";
		}
	}

	function closeCart() {
		$('.cart-main-container').removeClass('cart-main-container--opened');
		//$('body').removeClass('is-blocked');
		if (!$('body').hasClass('is-mobile')) {
			document.cookie = "is_cart_opened = no; path=/";
		}
	}

	function isCartOpened() {
		const cartContainer = $('.cart-main-container');
		if (cartContainer.length > 0) {
			if (cartContainer.hasClass('cart-main-container--opened')) {
				return true;
			}
		}
		return false;
	}

	function toggleCart(button, status) {
		if (button.length > 0) {
			button.on('click', function (e) {
				e.preventDefault();
				if (status == 'open') {
					const cartOpened = isCartOpened();
					if (cartOpened) {
						closeCart();
					} else {
						openCart();
					}
				} else {
					closeCart();
				}
			});
		}
	}

	function preventBodyScolling() {
		/*const cartOpened = isCartOpened();
		if (cartOpened) {
				$('body').addClass('is-blocked');
		}*/
	}

	/* Refresh Cart */
	function refreshHeaderCartIcon() {
		console.log('refreshHeaderCartIcon');
		jQuery.ajax({
			url: scriptData.ajaxUrl,
			method: 'post',
			dataType: 'json',
			data: {_ajax_nonce: scriptData.ajaxNonce, action: 'refresh_header_cart_icon',},
			success: function (response) {

				if (response) {
					console.log('refreshHeaderCartIcon - response');
					jQuery('body').find('.top-nav-cart__link').replaceWith(response);
					sessionStorage.setItem("top-nav-cart__link", response);
				}
			},
			error: function () {
				// console.log('connection error ');
			}
		});
	}

	function refreshCart() {
		console.log("refreshCart");
		$.ajax({
			url: scriptData.ajaxUrl,
			method: 'post',
			dataType: 'json',
			data: {
				_ajax_nonce: scriptData.ajaxNonce,
				action: 'refresh_cart'
			},
			success: function (response) {
				if (response) {

					$('.cart-main-container .cart-wrapper').html(response);
					sessionStorage.setItem("cart-wrapper", response);
					sessionStorage.setItem("cart-timestamp", new Date().getTime() + (1000 * 60 * 15));
					sessionStorage.removeItem("wp-wpml_current_language");
					document.cookie = "wp-wpml_current_language=; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=None; Secure";
					// Add event listeners again to cart after refreshing it
					toggleCart($('.close-cart-button'), 'close');
					removeProductFromCart();
					increaseQuantityValue($('.cart-product-quantity .quantity-plus'), true);
					decreaseQuantityValue($('.cart-product-quantity .quantity-minus'), true);
					addCoupon();
					removeCoupon();
				}
			},
			error: function () {
				// console.log('connection error ');
			}
		});
	}

	/* Change Cart Data */
	function addProductToCart() {
		const button = $('.coala-add-to-cart-button');
		if (button.length > 0) {
			button.on("click", function (e) {
				e.preventDefault();
				if(button.hasClass('block-cart')){
					return false;
				}
				sessionStorage.removeItem("cart-timestamp");
				const product_id = $(this).attr('value');
				const product_name = $(this).data('product_name');
				const product_value = $(this).data('product_value');
				const product_currency = $(this).data('product_curency');
				const variation_id = $('.variation_id').attr('value');
				const quantity = $('.quantity-wrapper input.qty').val();
				updatescriptData('add_product_to_cart', product_id, variation_id, quantity, null);
				addProductToCartEvent(product_id, variation_id, quantity, product_name, product_value, product_currency)
			});
		}
	}

	// add facebook event
	function addProductToCartEvent(product_id, variation_id, quantity, product_name, product_value, product_currency) {

		fbq('track', 'AddToCart', {
			source: "woocommerce",
			content_ids: "[\"wc_post_id_" + product_id + "\"]",
			content_name: product_name,
			contents: "[{\"id\":\"wc_post_id_" + product_id + "\",\"quantity\":" + quantity + "}]",
			content_type: 'product',
			value: product_value,
			currency: product_currency
		});
		console.log('fb event');
		console.log({
			source: "woocommerce",
			content_ids: "[\"wc_post_id_" + product_id + "\"]",
			content_name: product_name,
			contents: "[{\"id\":\"wc_post_id_" + product_id + "\",\"quantity\":" + quantity + "}]",
			content_type: 'product',
			value: product_value,
			currency: product_currency
		})
	}

	function refreshAfterAddedToCart() {
		$('body').on('added_to_cart', function () {
			refreshHeaderCartIcon();
			refreshCart();
		})
	}

	function removeProductFromCart() {
		const removeButton = $('.cart-wrapper .product-remove');
		if (removeButton.length > 0) {
			removeButton.on('click', function (e) {
				const removeLink = $(this).find('a').attr('href');
				const productKey = removeLink.split('item=')[1].split('&_wpnonce=')[0];
				e.preventDefault();
				sessionStorage.removeItem("cart-timestamp");
				updatescriptData('remove_product_from_cart', null, null, null, null, productKey);
			});
		}
	}

	function addCoupon() {
		const applyCoupon = $('.custom-cart-actions button[name="apply_coupon"]');
		if (applyCoupon.length > 0) {
			applyCoupon.on("click", function (e) {
				e.preventDefault();
				sessionStorage.removeItem("cart-timestamp");
				const coupon = $('.custom-cart-actions input[name="coupon_code"]').val();
				updatescriptData('apply_coupon', null, null, null, coupon);
			});
		}
	}

	function removeCoupon() {
		const removeCoupon = $('.cart-discount .woocommerce-remove-coupon');
		if (removeCoupon.length > 0) {
			removeCoupon.on("click", function (e) {
				e.preventDefault();
				sessionStorage.removeItem("cart-timestamp");
				const coupon = $(this).attr('data-coupon');
				updatescriptData('remove_coupon', null, null, null, coupon);
			});
		}
	}

	function updateCartQuantity(input) {
		enforceMinMax(input);
		const removeLink = input.closest('.cart_item').find('.product-remove a').attr('href');
		const productKey = removeLink.split('item=')[1].split('&_wpnonce=')[0];
		const productQty = input.val();

		sessionStorage.removeItem("cart-timestamp");
		updatescriptData('update_product_quantity', null, null, productQty, null, productKey);
	}

	function updateCartQuantityInput() {
		$('.woocommerce').on('change', '.cart-product-quantity input.qty', function (e) {
			e.preventDefault();
			updateCartQuantity($(this));
		});
	}

	function increaseQuantityValue(plus, cart = false) {
		if (plus.length > 0) {
			plus.on("click", function () {
				const input = $(this).siblings('.quantity').find('input');
				let inputVal = input.val();
				if (!inputVal) {
					inputVal = 0;
				}
				const newVal = parseInt(inputVal) + 1;
				input.val(newVal);
				enforceMinMax(input);
				if (cart) {
					updateCartQuantity(input);
				}
			});
		}
	}

	function decreaseQuantityValue(minus, cart = false) {
		if (minus.length > 0) {
			minus.on("click", function () {
				const input = $(this).siblings('.quantity').find('input');
				let newVal = parseInt(input.val()) - 1;
				if (newVal < 0) {
					newVal = 0;
				}
				input.val(newVal);
				enforceMinMax(input);
				if (cart) {
					updateCartQuantity(input);
				}
			});
		}
	}

	function blockCart() {
		jQuery('.woocommerce-cart-form').addClass('block-cart');
		jQuery('.coala-add-to-cart-button').addClass('block-cart');
	}

	function unBlockCart() {
		jQuery('.woocommerce-cart-form').removeClass('block-cart');
		jQuery('.coala-add-to-cart-button').removeClass('block-cart');
	}

	function updatescriptData(action, product_id, variation_id, quantity, coupon, productKey) {
		blockCart();
		$.ajax({
			url: scriptData.ajaxUrl,
			method: 'post',
			dataType: 'json',
			data: {
				_ajax_nonce: scriptData.ajaxNonce,
				action: action,
				'product_id': product_id,
				'variation_id': variation_id,
				quantity: quantity,
				coupon: coupon,
				'product_key': productKey
			},
			success: function (response) {
				if (response) {
					//refreshCart();

					$('.cart-main-container .cart-wrapper').html(response);
					sessionStorage.setItem("cart-wrapper", response);
					sessionStorage.setItem("cart-timestamp", new Date().getTime() + (1000 * 60 * 15));
					// Add event listeners again to cart after refreshing it
					hideCartNotices();
					toggleCart($('.close-cart-button'), 'close');
					removeProductFromCart();
					increaseQuantityValue($('.cart-product-quantity .quantity-plus'), true);
					decreaseQuantityValue($('.cart-product-quantity .quantity-minus'), true);
					addCoupon();
					removeCoupon();
					unBlockCart();
					if (action != 'apply_coupon' && action != 'remove_coupon') {
						refreshHeaderCartIcon();
					}

				}
			},
			error: function () {
				console.log('cart connection error ');
				unBlockCart();
			}
		});
	}

	/* Load more orders on my-account page */
	function loadMoreOrders() {
		const button = $('.load-more-orders');
		if (button.length > 0) {
			const ordersTable = $('.woocommerce-orders-table');
			const totalPages = ordersTable.attr('data-orders-total');
			let currentOrdersPage = ordersTable.attr('data-orders-page');
			if (currentOrdersPage == 0) {
				currentOrdersPage = 1;
			}
			currentOrdersPage = parseInt(currentOrdersPage) + 1;
			button.on('click', function () {
				$.ajax({
					url: scriptData.ajaxUrl,
					method: 'post',
					dataType: 'json',
					data: {_ajax_nonce: scriptData.ajaxNonce, action: 'load_more_orders', page: currentOrdersPage},
					success: function (response) {
						if (response) {
							const tableBody = $('.woocommerce-orders-table tbody');
							tableBody.append(response);
							currentOrdersPage += 1;
							if (tableBody.children().length >= totalPages) {
								button.css({display: 'none'});
							}
						}
					},
					error: function (err1, err2, err3) {
						// console.log('connection error ', err2, err3 );
					}
				});
			});
		}
	}

	/* Load more products on shop page */
	function loadMoreProducts() {
		if ($('body').find('.load-more-products').length > 0) {

			$(window).scroll(function () {
				if (jQuery('body').find('.load-more-button-wrapper').data('loading') !== true) {
					//if (jQuery(window).scrollTop() >= jQuery(document).height() - jQuery(window).height() - (jQuery('footer').height() * 2)) {
					if(jQuery(window).scrollTop() + jQuery(window).height() > jQuery(document).height() - jQuery('footer').height() * 2) {
						console.log('click more');
						jQuery('body').find('.load-more-products').click();
					}
				}
			});

			const productsContainer = $('.main .container .products');
			$('body').on('click tap', '.load-more-products', function () {
				const button = $(this);
				if (button.parent('.load-more-button-wrapper').data('loading') === true) {
					return;
				}
				button.parent('.load-more-button-wrapper').data('loading', true);
				const searchedKey = button.attr('data-search-key');
				const category = button.attr('data-category');
				const tag = button.attr('data-tag');
				const nextPage = parseInt(button.attr('data-page'));
				$.ajax({
					url: scriptData.ajaxUrl,
					method: 'post',
					dataType: 'json',
					data: {
						_ajax_nonce: scriptData.ajaxNonce,
						action: 'load_more_products',
						page: nextPage,
						searched_key: searchedKey,
						category: category,
						tag: tag
					},
					beforeSend: function () {
						button.fadeOut('fast', function () {
							button.parent('.load-more-button-wrapper').find('img.loader').fadeIn('fast');
						});
					},
					success: function (response) {
						button.parent('.load-more-button-wrapper').fadeOut('fast', function () {
							$(this).remove();
						});
						if (response[0]) {
							productsContainer.append(response[0]).ready(function () {
								rowEQheight();
							});
							/*const totalPages = response[1];
							currentPage += 1;
							if (productsContainer.children('.product-item').length >= totalPages) {
								button.css({display: 'none'});
							}*/
						}
					},
					error: function (err1, err2, err3) {
						// console.log('connection error ', err2, err3 );
					}
				});
			});
		}
	}

	/* Toggle language swithes */
	function toggleLanguageSwitcher() {
		/*		const currentLanguage = $('.current-language');
				if (currentLanguage.length > 0) {
					currentLanguage.on('click tap', function () {
						$(this).siblings('.lang-switcher').toggle();
					});
				}*/
		const currentLanguage = $('.lang-chose');
		if (currentLanguage.length > 0) {
			currentLanguage.mouseenter(function () {
				$(this).find('.lang-switcher').fadeIn('fast');
			}).mouseleave(function () {
				$(this).find('.lang-switcher').fadeOut('fast');
			});
		}
	}

	/* Toggle curency swithes */
	function toggleCurrencySwitcher() {
		/*const currentLanguage = $('.current-lang-currency');
		if (currentLanguage.length > 0) {
			currentLanguage.on('click tap', function () {
				$(this).siblings('.currency-switcher').toggle();
			});
		}*/
		const currentCurrency = $('.curency-chose');
		if (currentCurrency.length > 0) {
			currentCurrency.mouseenter(function () {
				$(this).find('.currency-switcher').fadeIn('fast');
			}).mouseleave(function () {
				$(this).find('.currency-switcher').fadeOut('fast');
			});
		}
	}

	function shareLink() {
		const shareIcon = $('.share-icon');
		if (shareIcon.length > 0) {
			shareIcon.on('click tap', function () {
				const url = window.location.href;
				const temp = $("<input>");
				$("body").append(temp);
				temp.val(url).select();
				document.execCommand("copy");
				temp.remove();
				$('.copied-link-info').addClass('copied-link-info--visible');
				$('.copied-link-info').delay(3000).queue(function () {  // Wait for 3 seconds and remove class.
					$(this).removeClass("copied-link-info--visible").dequeue();
				});
			});
		}
	}


	function checkoutDeliveryToDifferentAddress() {
		if (jQuery('.ship-to-radio').length) {
			jQuery('.ship-to-radio:radio').change(function () {
				var curval = $(this).val();
				//jQuery('#ship-to-different-address-checkbox').prop('checked', curval);
				jQuery('#ship-to-different-address-checkbox:checkbox').trigger('click');
			});
		}
	}

	function navOnCheckout() {
		if (jQuery('.woo-checkout-nav').length) {

			jQuery("form.checkout").keypress(function (e) {
				//Enter key
				if (e.which == 13) {
					return false;
				}
			});

			jQuery(document).on('click tap', '.woo-checkout-nav-item', function () {
				var targetSection = jQuery(this).data('checkout-to');
				if (checkoutValidationTest(targetSection)) {
					console.log('valid step')
					/* change URL and add history checkout */
					//window.history.replaceState({}, '', updateURLParameter(window.location.href, "checkout-to", targetSection));
					window.history.pushState({}, '', updateURLParameter(window.location.href, "checkout-to", targetSection));

					/* end history checkout */

					if (!jQuery('.' + targetSection).hasClass('active')) {
						jQuery('.woo-checkout-nav-item').removeClass('active');
						jQuery('.woo-checkout-item').removeClass('active').slideUp('fast', function () {
							jQuery('.' + targetSection).slideDown('fast').addClass('active');
							jQuery('.woo-checkout-nav-item[data-checkout-to="' + targetSection + '"]').addClass('active');

							$('html, body').animate({
								scrollTop: $('.woo-checkout-nav').offset().top - 50 // substract menu height (rounded)
							}, 200);
						});
					}
					getDataFromCheckoutSteps();

				}
			});


		}
	}

	function navOnHistoryBack() {
		//addEventListener("popstate", function (e) {
		jQuery(window).on('popstate', function (e) {
			const urlParams = new URLSearchParams(window.location.search);
			let targetSection = urlParams.get('checkout-to');
			console.log(targetSection);
			if (targetSection !== 'undefined') {
				//jQuery('.woo-checkout-nav-item[data-checkout-to="'+param+'"]').click();

				if (!jQuery('.' + targetSection).hasClass('active')) {
					jQuery('.woo-checkout-nav-item').removeClass('active');
					jQuery('.woo-checkout-item').removeClass('active').slideUp('fast', function () {
						jQuery('.' + targetSection).slideDown('fast').addClass('active');
						jQuery('.woo-checkout-nav-item[data-checkout-to="' + targetSection + '"]').addClass('active');

						$('html, body').animate({
							scrollTop: $('.woo-checkout-nav').offset().top - 50 // substract menu height (rounded)
						}, 200);
					});
				}

			}
			e.preventDefault();
		});
	}

	function checkNavOnCheckout() {
		if (jQuery('.woo-checkout-nav').length) {
			var targetSection = jQuery('.woo-checkout-nav-item.active').data('checkout-to');
			jQuery('.' + targetSection).slideDown('fast').addClass('active');
		}
	}

	function getDataFromCheckoutSteps() {
		if (jQuery('.woo-log-checkout').length) {
			var contactWrapper = jQuery('.woo-log-contact');
			var shippingWrapper = jQuery('.woo-log-shipping');
			var shippingMethodWrapper = jQuery('.woo-log-shipping-method');

			/* forms */
			/* 1 */
			var billing_first_name = jQuery('#billing_first_name').val();
			var billing_last_name = jQuery('#billing_last_name').val();
			var billing_company = jQuery('#billing_company').val();
			var billing_email = jQuery('#billing_email').val();

			/* 2 */
			var billing_postcode = jQuery('#billing_postcode').val();
			var billing_address_1 = jQuery('#billing_address_1').val();
			var billing_address_2 = jQuery('#billing_address_2').val();
			var billing_city = jQuery('#billing_city').val();

			/* different delivery */
			var shipToDifferentAddress = jQuery('#ship-to-different-address-radio:checked').val()
			/* 1 */
			var shipping_first_name = jQuery('#shipping_first_name').val();
			var shipping_last_name = jQuery('#shipping_last_name').val();
			//var shipping_company = jQuery('#shipping_company').val();

			/* 2 */
			var shipping_postcode = jQuery('#shipping_postcode').val();
			var shipping_address_1 = jQuery('#shipping_address_1').val();
			var shipping_address_2 = jQuery('#shipping_address_2').val();
			var shipping_city = jQuery('#shipping_city').val();

			/* Delivery method data */
			var shipping_method = jQuery(".shipping_method:checked").next('label').html();

			contactWrapper.slideUp();
			shippingWrapper.slideUp();
			shippingMethodWrapper.slideUp();
			if (billing_first_name.length && billing_last_name.length && billing_email.length) {
				contactWrapper.find('.log-col-second').html(billing_first_name + ' ' + billing_last_name + '<br>' + billing_email);
				contactWrapper.slideDown();
			}

			if (shipToDifferentAddress === '1') {
				console.log('to different')
				if (shipping_address_1.length && shipping_city.length) {
					shippingWrapper.find('.log-col-second').html(shipping_postcode + '<br> ' + shipping_address_1 + ' ' + shipping_address_2 + '<br>' + shipping_city);
					shippingWrapper.slideDown();
				}
			} else {
				if (billing_address_1.length && billing_city.length) {
					shippingWrapper.find('.log-col-second').html(billing_postcode + '<br> ' + billing_address_1 + ' ' + billing_address_2 + '<br>' + billing_city);
					shippingWrapper.slideDown();
				}
			}
			if (shipping_method !== undefined && shipping_method.length > 0) {
				shippingMethodWrapper.find('.log-col-second').html(shipping_method);
				shippingMethodWrapper.slideDown();
			}

		}
	}

	function validateCheckout(error_message) {
		var noticeWrapper = jQuery('.woocommerce-NoticeGroup');
		// if (noticeWrapper.length) {
		//
		// }
	}

	function checkoutValidationTest(goToStep) {
		const activeStep = jQuery('.woo-checkout-nav-item.active').data('checkout-to');
		const validateArray = [];

		if (activeStep === 'woo-information') {
			jQuery('#woo-information #customer_details .validate-required.woocommerce-invalid, #woo-information #customer_details .validate-req.woocommerce-invalid').removeClass('woocommerce-invalid-required-field')
			jQuery('#woo-information #customer_details .validate-required, #woo-information #customer_details .validate-req').each(function () {
				if (jQuery(this).find('input').val() !== undefined && jQuery(this).find('input').val().length !== 0) {
					validateArray.push('true');
					//console.log(jQuery(this).find('input').val());
				} else if (jQuery(this).find('select').val() !== undefined && jQuery(this).find('select').val().length !== 0) {
					validateArray.push('true');
					//console.log(jQuery(this).find('select').val());
				} else {
					console.log(jQuery(this));
					jQuery(this).addClass('woocommerce-invalid');
					validateArray.push('false');
				}
			});
			console.log(validateArray);
			if (jQuery.inArray('false', validateArray) === -1) {
				console.log('go next 1');
				jQuery('.woocommerce-NoticeGroup').remove();
				return true;
			}
			console.log('stop 1');
			$('body').trigger('update_checkout');
			checkoutValidationTestMessage(scriptData.validationStep1, true);
			return false;

		}
		if (activeStep === 'woo-shipping') {
			if (goToStep === 'woo-information') {
				jQuery('.woocommerce-NoticeGroup').remove();
				return true;
			}
			//if multiple shipping method
			//const shippingMethods = jQuery('#shipping_method input');
			console.log(jQuery('#shipping_method input[type=\'radio\']:checked').val());
			if (jQuery('#shipping_method input[type=\'radio\']:checked').val() !== undefined) {
				console.log('go next 2');
				jQuery('.woocommerce-NoticeGroup').remove();
				return true;
			} else if (jQuery('#shipping_method input[type=\'hidden\']').val() !== undefined) {
				console.log('go next 2');
				jQuery('.woocommerce-NoticeGroup').remove();
				return true;
			}
			console.log('stop 2');
			checkoutValidationTestMessage(scriptData.validationStep2, true);
			return false;
		}
		if (activeStep === 'woo-payment') {
			jQuery('.woocommerce-NoticeGroup').remove();
			return true;
		}
		return false;
	}

	function checkoutValidationTestMessage(whyText, wrap) {
		jQuery('.woocommerce-NoticeGroup').remove();

		if (wrap) {
			jQuery('form.checkout').prepend(
				'<div class="woocommerce-NoticeGroup"><ul class="woocommerce-error" role="alert"><li>' + whyText.replace(/<[^>]*>?/gm, '') + '</li></ul></div>');
		} else {
			jQuery('form.checkout').prepend(
				'<div class="woocommerce-NoticeGroup">' + whyText + '</div>');
		}

		jQuery('html, body').animate({
			scrollTop: jQuery('.woo-checkout-nav').offset().top - 50 // substract menu height (rounded)
		}, 200);
	}


	function checkoutSelectType() {
		let selectTypeWrapper = jQuery('.select-type-wrapper');

		/* switcher */
		if (selectTypeWrapper.length) {
			let companyOpen = getCookie('checkout-company');
			let companyName = jQuery('#billing_company');
			let companyVat = jQuery('#woocommerce_eu_vat_number');

			/* show base on cookies */
			if (companyOpen === 'yes') {
				checkoutSelectTypeOption('company');
			}

			/* show base on data in company fields */
			if (companyName.val() || companyVat.val()) {
				checkoutSelectTypeOption('company');
			} else {
				jQuery('.select-type.select-personal').addClass('active');
			}

			selectTypeWrapper.find('.select-type').on('click tap', function () {

				var selected = jQuery(this).data('select');
				checkoutSelectTypeOption(selected);

			});
		}
	}

	function checkoutSelectTypeOption(selected) {
		let companyName = jQuery('#billing_company');
		let companyVat = jQuery('#woocommerce_eu_vat_number');

		if (selected === 'company') {
			jQuery('.form-company').slideDown('fast');
			document.cookie = "checkout-company = yes; path=/";
			jQuery('.select-type').removeClass('active');
			jQuery('.select-type.select-company').addClass('active');
		} else {
			jQuery('.form-company').slideUp('fast');
			companyName.val('');
			companyVat.val('');
			document.cookie = "checkout-company = no; path=/";
			jQuery('.select-type').removeClass('active');
			jQuery('.select-type.select-personal').addClass('active');
		}
	}

	function showHideCategoryNav() {
		let navButton = jQuery('.woocmmerce-shop-nav-filter');
		let navMenu = jQuery('.woocmmerce-shop-nav');

		if (navButton.length) {
			navButton.on('click', function () {
				console.log('click');
				if (navButton.hasClass('active')) { // opened menu
					navButton.removeClass('active');
					navMenu.slideUp('fast').removeClass('active');
				} else { // closed menu
					navButton.addClass('active');
					navMenu.slideDown('fast').addClass('active');
				}
			})
		}
	}

	function showHideCategoryNavSumbenu() {
		let navCategoryManu = jQuery('.woocommerce-category-nav-menu');
		let secondNavMenu = jQuery('.widget_nav_menu');
		if (navCategoryManu.length) {
			let tapped = false;

			navCategoryManu.find('li > a > span').on('click tap', function (e) {
				e.preventDefault();
				let theOne = $(this);

				if ($(window).width() < 992) {

					// close all on click
					theOne.parent().parent().parent().find('.open-submenu').not(theOne.closest('ul')).removeClass("open-submenu");
					theOne.parent().parent().parent().find('.active').not(theOne.closest('li')).removeClass("active");

					//open only clicked
					if (theOne.parent().parent('li.active').length) {
						theOne.parent().parent('li.active').removeClass("active").find('ul.open-submenu').removeClass("open-submenu");

					} else if (theOne.parent().parent('li').length) {
						theOne.parent().parent('li').addClass("active");
						theOne.parent().parent('li').find('ul').eq(0).addClass("open-submenu");
					}
				}
				// if ($(window).width() < 992 && theOne.closest('ul').find('.woocommerce-category-nav-submenu-2').length) {
				// 	navCategoryManu.find('.open-submenu').not(theOne.closest('ul')).removeClass("open-submenu");
				// 				theOne.closest('ul').find('ul').toggleClass("open-submenu");
				// 				//showHideCategoryNavSumbenuheight();
				//
				// 				//secondNavMenu.toggleClass("hidden");
				//
				// }
				// else if ($(window).width() < 992 && theOne.closest('ul').find('.woocommerce-category-nav-submenu').length) {
				// 	navCategoryManu.find('.open-submenu').not(theOne.closest('ul')).removeClass("open-submenu");
				// 				theOne.closest('ul').toggleClass("open-submenu");
				// 				//showHideCategoryNavSumbenuheight();
				//
				// 				//secondNavMenu.toggleClass("hidden");
				//
				// }


				// if ($(window).width() < 992 && jQuery(this).parent().find('.woocommerce-category-nav-submenu-2').length) {
				// 	let theOne = $(this);
				// 	e.preventDefault();
				//
				// 	if ((!tapped)) {
				// 		tapped = setTimeout(function () {
				// 			//single tap function
				//
				// 			//navCategoryManu.find('.open-sumbmenu').not(theOne.parent()).removeClass("open-sumbmenu");
				// 			theOne.parent().toggleClass("open-sumbmenu");
				// 			showHideCategoryNavSumbenuheight();
				//
				// 			//secondNavMenu.toggleClass("hidden");
				// 			e.preventDefault();
				// 			tapped = null;
				//
				//
				// 		}, 300); //wait 300ms
				//
				// 	} else {
				// 		//double tap function
				//
				// 		clearTimeout(tapped);
				// 		tapped = null;
				// 		window.location = $(this).attr("href");
				// 	}
				// 	//
				// } else if ($(window).width() < 992 && jQuery(this).parent().find('.woocommerce-category-nav-submenu').length) {
				// 	let theOne = $(this);
				// 	e.preventDefault();
				//
				// 	if ((!tapped)) {
				// 		tapped = setTimeout(function () {
				// 			//single tap function
				//
				// 			navCategoryManu.find('.open-sumbmenu').not(theOne.parent()).removeClass("open-sumbmenu");
				// 			theOne.parent().toggleClass("open-sumbmenu");
				// 			showHideCategoryNavSumbenuheight();
				//
				// 			secondNavMenu.toggleClass("hidden");
				// 			e.preventDefault();
				// 			tapped = null;
				//
				//
				// 		}, 300); //wait 300ms
				//
				// 	} else {
				// 		//double tap function
				//
				// 		clearTimeout(tapped);
				// 		tapped = null;
				// 		window.location = $(this).attr("href");
				// 	}
				// 	//
				// }

			});
		}
	}

	// count height for menu if submenu is open
	function showHideCategoryNavSumbenuheight() {
		const navCategoryMenu = jQuery('.woocommerce-category-nav-menu');
		let subnavHeight = 0;
		navCategoryMenu.find('.open-submenu').each(function () {
			subnavHeight += $(this).outerHeight();
		});

		navCategoryMenu.css('min-height', 'auto');


		navCategoryMenu.css('min-height', navCategoryMenu.outerHeight() + subnavHeight);
	}

	function stopAddMoreProductByInput() {
		$('body').find("input[type=number]").keyup(function () {
			// Check correct, else revert back to old value.
			console.log('keyUP');
			enforceMinMax($(this));
		});
	}

	function enforceMinMax(el) {
		console.log(el.prop('min'));
		console.log(el.prop('max'));
		if (el.val() != "") {
			if (parseInt(el.val()) < parseInt(el.prop('min'))) {
				el.val(el.prop('min'));
			}
			if (parseInt(el.val()) > parseInt(el.prop('max'))) {
				el.val(el.prop('max'));
			}
		}
	}

	function hideCartNotices() {
		$('body').find('.notices-lightbox').each(function (e) {

			$('body').find('.woocommerce-notices-lightbox-wrapper').append($(this));

			let container = $('body').find('.woocommerce-notices-lightbox-wrapper .notices-lightbox');
			console.log($(this));
			container.on('click tap', function () {
				jQuery(this).fadeOut('slow').remove();
			})
			setTimeout(function () {
				container.fadeOut('slow').remove();

			}, 1500);
		});

		$('body').find('.woocommerce-notices-wrapper .woocommerce-message').each(function (e) {

			$(this).wrap('<div class="notices-lightbox"></div>');
			console.log($(this));
			//$('body').find('.woocommerce-notices-lightbox-wrapper').append('<div class="notices-lightbox">' + $(this).html() + '</div>');

			let container = $('body').find('.woocommerce-notices-wrapper .notices-lightbox');

			container.on('click tap', function () {
				jQuery(this).fadeOut('slow').remove();
			})
			setTimeout(function () {
				container.fadeOut('slow').remove();

			}, 1500);
		});
	}


	function updateURLParameter(url, param, paramVal) {
		var TheAnchor = null;
		var newAdditionalURL = "";
		var tempArray = url.split("?");
		var baseURL = tempArray[0];
		var additionalURL = tempArray[1];
		var temp = "";

		if (additionalURL) {
			var tmpAnchor = additionalURL.split("#");
			var TheParams = tmpAnchor[0];
			TheAnchor = tmpAnchor[1];
			if (TheAnchor)
				additionalURL = TheParams;

			tempArray = additionalURL.split("&");

			for (var i = 0; i < tempArray.length; i++) {
				if (tempArray[i].split('=')[0] != param) {
					newAdditionalURL += temp + tempArray[i];
					temp = "&";
				}
			}
		} else {
			var tmpAnchor = baseURL.split("#");
			var TheParams = tmpAnchor[0];
			TheAnchor = tmpAnchor[1];

			if (TheParams)
				baseURL = TheParams;
		}

		if (TheAnchor)
			paramVal += "#" + TheAnchor;

		var rows_txt = temp + "" + param + "=" + paramVal;
		return baseURL + "?" + newAdditionalURL + rows_txt;
	}

	//reload on back button
	window.addEventListener("pageshow", function (event) {
		// var historyTraversal = event.persisted ||
		// 		(typeof window.performance != "undefined" &&
		// 				window.performance.navigation.type === 2);
		// if (historyTraversal) {
		// 	// Handle page restore.
		// 	console.log('reload on back');
		// 	window.location.reload();
		// 	//refreshHeaderCartIcon();
		// 	//refreshCart();
		// }
		var historyTraversal = event.persisted ||
			(typeof window.performance != "undefined" &&
				window.performance.navigation.type === 2);
		if (historyTraversal) {
			refreshCartAndIconFromLocal();
		}
	});

	function refreshCartAndIconFromLocal() {

		var actualTime = new Date().getTime();
		var cartTime = sessionStorage.getItem("cart-timestamp");
		var cartLanguage = sessionStorage.getItem("cart-language");
		console.log('actual time:' + actualTime);
		console.log('cart time:' + cartTime);
		console.log('cart language:' + cartLanguage);
		if (cartTime > actualTime && cartLanguage === getCookieLang('wp-wpml_current_language')) {

			var cart = sessionStorage.getItem('cart-wrapper');
			var cartIcon = sessionStorage.getItem('top-nav-cart__link');

			if (cartIcon !== 'undefined') {
				console.log('local cart icon:')
				jQuery('.cart-main-container .cart-wrapper').html(cart);
				jQuery('body').find('.top-nav-cart__link').replaceWith(cartIcon);
			}
			if (cart !== 'undefined') {
				console.log('local cart:')
				jQuery('.cart-main-container .cart-wrapper').html(cart);
				if (jQuery('.close-cart-button').length) {
					toggleCart(jQuery('.close-cart-button'), 'close');
				}
				removeProductFromCart();
				increaseQuantityValue($('.cart-product-quantity .quantity-plus'), true);
				decreaseQuantityValue($('.cart-product-quantity .quantity-minus'), true);
				addCoupon();
				removeCoupon();
			}
			$('body').find('.notices-lightbox').remove();
		} else {
			console.log('refresh cart:')
			sessionStorage.setItem("cart-language", getCookieLang('wp-wpml_current_language'));
			refreshHeaderCartIcon();
			refreshCart();
		}
	}

	function selectDefaultCountry() {
		if (jQuery('#shipping_country').length && jQuery('#shipping_country').val() === '') {
			jQuery('#shipping_country').val('PL').change();
		}
		if (jQuery('#billing_country').length && jQuery('#billing_country').val() === '') {
			jQuery('#billing_country').val('PL').change();
		}
	}

	function clearCartAfterAddToCartBundleProduct() {
		const button = $('.bundle-add-to-cart-button');
		if (button.length > 0) {
			button.on('click tap', function (e) {
				sessionStorage.removeItem("cart-timestamp");
			});
		}
	}

	function catchLoginRegisterNotices(){
		if($('body').find('.cart-wrapper .woocommerce-notices-wrapper').length > 0){

			$('body').find('.cart-wrapper .woocommerce-notices-wrapper').each(function (e) {
				let whyText = jQuery(this).html();

				jQuery('.woocommerce .woocommerce-notices-wrapper').append(
					'' + whyText + '');
			});

			$('body').find('.cart-wrapper .woocommerce-notices-wrapper ul').remove();
		}

	}

})(jQuery);


